export const getLocaleFromCurrencyCode = (currencyCode: string): string => {
    switch (currencyCode) {
        case 'BRL':
            return 'pt-BR';
        case 'EUR':
            return 'es-ES';
        case 'MXN':
            return 'es-MX';
        default:
            return 'en-US';
    }
};

export const formatCurrency = (
    amount: number,
    currencyCode: string,
    locale?: string | null | undefined,
): string => {
    const validCurrencyCode =
        currencyCode && currencyCode.trim() !== ''
            ? currencyCode.trim()
            : 'BRL';

    return new Intl.NumberFormat(
        locale ?? getLocaleFromCurrencyCode(validCurrencyCode),
        {
            style: 'currency',
            currency: validCurrencyCode,
        },
    ).format(amount);
};
